module.exports = __webpack_public_path__ + "img/duli-pop.9113ec4a.png";